
// See also ./plugin/vuetify.js and themes.js

const beringarColourSets = {
  chart: [
    '#5a81f5ff',
    '#146DEAff',
    '#1856f5ff',
    '#0000BDff',
    '#0D93BFff',
    '#0A7DA4ff',
    '#076586ff',
    '#6A51C2ff',
    '#5920dbff',
    '#4E40A2ff'
  ],
  chartOld1: [
    '#0000ffff',
    '#146deaff',
    '#6100f0ff',
    '#9744ffff',
    '#FFA947',
    '#ffd100ff',
    '#434343ff',
    '#777777ff',
    '#00934eff',
    '#8efcc7ff'],
  material: {
    primaryColor: '#ffffff',
    primaryLightColor: '#ffffff',
    primaryDarkColor: '#cccccc',
    secondaryColor: '#0000ff',
    secondaryLightColor: '#7142ff',
    secondaryDarkColor: '#0000ca',
    primaryTextColor: '#000000',
    secondaryTextColor: '#ffffff'
  }
}

export default beringarColourSets
